module.exports = __webpack_public_path__ + "/login_ui/img/es-e41ce34b2e0be1516822d8250239e6f7.svg";